const resizeMap = new WeakMap<Element, ResizeObserver>();

export const add = (element: Element, fn: ResizeObserverCallback) => {
	if (!resizeMap.has(element)) {
		const observer = new ResizeObserver(fn);
		observer.observe(element);
		resizeMap.set(element, observer);
	}
};

export const remove = (element: Element) => {
	const observer = resizeMap.get(element);
	if (observer) {
		observer.disconnect();
		resizeMap.delete(element);
	}
};
